import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameBestList = paths['/v4/game/best/'];

const getGameBestList = createRequest<GameBestList>('/pc/v4/game/best/');

export default getGameBestList;
